<template>
  <div style="position: relative; overflow-x: clip;">
    <Section class="find-it">
      <div class="d-flex px-1" >
        <div class="mr-auto">
          <span class="black--text font-weight-bold">Received</span><br>
          {{ formatRelative(lead.lead_date) }} &nbsp;({{ formatDate(lead.lead_date )}})<br>
          Lead Cost: <span v-if="lead.price_cents > 0">{{ formatCurrency(lead.price_cents) }} <em>(+ tax)</em></span>
          <span v-else>Free!</span>
        </div>
        <StatusSelect v-if="!isRefunded" :value="lead.status" @input="updateStatus"/>
      </div>

      <v-divider class="my-3"/>
      
      <div class="px-1">
        <span class="black--text font-weight-bold">Job Details</span><br>
        {{ lead.friendly_structure_type ? lead.friendly_structure_type + ' - ' : '' }}{{ lead.service }}<br>
        <span v-if="lead.notes && !isRefunded">{{ lead.notes }}<br></span>
      </div>

      <v-divider class="my-3"/>
      
      <div class="px-1" v-if="!isRefunded">
        <span class="black--text font-weight-bold">Contact</span><br>
        {{ lead.customer.name }}<br>
        <a :href="`tel:${ lead.customer.phone }`">{{ lead.customer.phone}}</a><br>
        Zipcode: {{ lead.customer.zipcode }}
      </div>

      <div class="px-1" v-else>
        <span class="black--text font-weight-bold">Contact</span><br>
        Removed due to refund...<br>
        Zipcode: {{ lead.customer.zipcode }}
      </div>

      <v-divider class="my-3"/>
      
      <div class="px-1">
        <div class="d-flex mb-3" style="width: 100%">
          <span class="black--text font-weight-bold">Sample customer message:</span><br>
          <v-btn
            x-small rounded
            color="primary"
            class="ml-auto"
            :href="`sms:+1${ lead.customer.phone }?body=${ message }`"
          >
            text customer
          </v-btn>
        </div>


        Hi, this is {{ me.business_name }},<br><br>

        {{ lead.account.account_name }} suggested 
        I get in touch about your {{ lead.service }} needs. I'll give you
        a call soon, or you can reach out to me anytime.<br><br>

        I'm looking forward to talking about your project.
      </div>

      <v-divider class="my-3"/>
      
      <div class="px-1">
        <span class="black--text font-weight-bold">From</span><br>
        {{ lead.account.account_name }}<br>
      </div>
    </Section>

    <div v-if="isDisputed" class="overlay">Pending Review</div>
    <div v-else-if="isRefunded" class="overlay">Refunded</div>
  </div>
</template>

<script>
import { Section } from '@/components/pages'
import { StatusSelect } from '@/components/inputs'
import { mapActions, mapGetters } from 'vuex'
import formatters from '@/lib/formatters'

export default {
  name: 'LeadBaseSection',

  components: { Section, StatusSelect },

  props: {
    lead: { type: Object, required: true },
  },

  computed: {
    ...mapGetters('auth', { me: 'me' }),

    isDisputed() {
      return this.lead.system_status == 'disputed'
    },

    isRefunded() {
      return this.lead.system_status == 'refunded'
    },

    message() {
      return encodeURIComponent(
        `Hi, this is ${ this.me.business_name },\n\n` +
        `${ this.lead.account.account_name } suggested I get in touch about your ${ this.lead.service } needs. I'll give you a call soon, or you can reach out to me anytime.\n\n` +
        "I'm looking forward to talking about your project."
      )
    },
  },

  methods: {
    ...mapActions('leads', ['updateCurrent']),

    ...formatters,

    updateStatus(newStatus) {
      const lead = { lead_id: this.lead.lead_id, status: newStatus }

      this.updateCurrent(lead)
    },
  },
}
</script>

<style scoped>
  .overlay {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 48px;
    font-weight: bold;
    color: rgba(0,0,0,0.3);
    transform: rotate(-45deg);
    text-align: center;
  }
</style>